import type { ReactNode } from 'react';
import type { IconComponent } from './icons';

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  icon?: IconComponent;
  eyebrow?: string;
  children?: ReactNode;
}

export default function PageHeader({ title, description, icon: Icon, eyebrow, children }: PageHeaderProps) {
  return (
    <header className="page-heading">
      <div className="page-heading-row">
        {Icon && <span className="page-icon"><Icon size={24} aria-hidden="true" /></span>}
        <div className="min-w-0 flex-1">
          {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
          <h1 className="page-title">{title}</h1>
          {description && <p className="page-description">{description}</p>}
          {children}
        </div>
      </div>
    </header>
  );
}
